import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Text from 'pf9-ui-components/built/elements/Text'
import React from 'react'
import UsageProgressBar from './UsageProgressBar'

const UsageProgress = ({ value }) => {
  const classes = useStyles()
  if (!value || value?.current === undefined || value?.total === undefined) return null
  const percent = value?.total > 0 ? (value?.current / value?.total) * 100 : 0
  const label = `(${value?.current} / ${value?.total})`
  return (
    <div className={classes.cardsRow} data-testid="usage-progress-cards-row">
      <div className={classes.rightContent} data-testid="usage-progress-right-content">
        <Text variant="caption1" data-testid="usage-progress-percentage-text">
          {percent?.toFixed(2)}%
        </Text>{' '}
        <Text className={classes.subText} variant="body2" data-testid="usage-progress-label-text">
          {label}
        </Text>
      </div>
      <UsageProgressBar percent={percent} />
    </div>
  )
}
export default UsageProgress

const useStyles = makeStyles((theme: Theme) => ({
  rightContent: {
    marginTop: '0.5rem',
    display: 'flex',
    alignItems: 'center', // Ensures vertical alignment
  },
  cardsRow: {
    display: 'grid',
    gap: theme.spacing(1),

    '& .progress-container': {
      maxWidth: '170px',
    },
  },
  subText: {
    paddingLeft: theme.spacing(1),
  },
}))
